module.exports = __webpack_public_path__ + "static/media/isdoctorplan-ent3@3x.86804f11.png";